import React, { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import PencilIcon from 'images/v5/icons/edit-02.svg';
import TrashSvg from 'images/v5/icons/trash-03.svg';
import Avatar from 'layout/atoms/Avatar/Avatar';
import Button from 'layout/atoms/Button/Button';
import Dropdown from 'layout/atoms/Dropdown/Dropdown';
import Loader from 'layout/atoms/Loader/Loader';
import { Cell, Row } from 'layout/atoms/TableGrid';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import Grid from 'molecules/Grid/Grid';
import parseImage from 'parsers/common/parseImage';
import { openModal } from 'store/layoutSlice';
import ParametersTable from '../shared/ParametersTable';
import styles from './ProductParameterTable.module.scss';
function ProductParameterTable({ config, toolbar }) {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification', 'common']);
    const items = useSelector(config.selectItems);
    const pageInfo = useSelector(config.selectPageInfo);
    const status = useSelector(config.selectStatus);
    const errors = useSelector(config.selectErrors);
    const refetchFlags = useSelector(config.selectRefetchFlags);
    const fetchMore = () => {
        if (pageInfo.hasNextPage && status.fetch !== 'loading') {
            dispatch(config.fetchItems());
        }
    };
    useEffect(() => {
        if (status.fetch === 'idle' || refetchFlags.fetch) {
            dispatch(config.fetchItems());
        }
    }, [config, dispatch, status.fetch, refetchFlags.fetch]);
    const handleDelete = (id) => {
        dispatch(config.removeItem(id));
    };
    if (status.fetch === 'loading' || status.fetch === 'idle') {
        return React.createElement(Loader, null);
    }
    if (status.fetch === 'failed') {
        return React.createElement("div", null, errors.fetch);
    }
    return (React.createElement(Grid, { gap: 24 },
        React.createElement("div", { className: styles.toolbar }, toolbar),
        items.length === 0 ? (React.createElement(EmptyState, null)) : (React.createElement(ParametersTable, { columns: [
                ['240px', '320px'],
                ['320px', '1fr'],
                ['72px', 'auto'],
            ], headers: [
                { content: t('common:name') },
                { content: t('description') },
                { content: null },
            ], dataLength: items.length, hasMore: pageInfo.hasNextPage, fetchMore: fetchMore }, items.map((item) => (React.createElement(Row, { key: item.id },
            React.createElement(Cell, null,
                React.createElement(Avatar, { src: parseImage(item.thumbnail) || '', userName: item.name }),
                React.createElement("p", null, item.name)),
            React.createElement(Cell, null,
                React.createElement("span", { className: styles.description }, item.description || '-')),
            React.createElement(Cell, null,
                React.createElement(Dropdown, null,
                    React.createElement(Button, { size: "m", align: "left", theme: "ghost", leftIcon: React.createElement(PencilIcon, null), onClick: () => dispatch(openModal({ name: config.editorModalName, id: item.id })) }, t('common:edit')),
                    React.createElement(Button, { size: "m", align: "left", theme: "ghost", color: "danger", leftIcon: React.createElement(TrashSvg, null), onClick: () => handleDelete(item.id) }, t('common:delete')))))))))));
}
export default memo(ProductParameterTable);
